import React, {useEffect} from 'react';
import {FormControl, Input} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import EventIcon from '@material-ui/icons/Event';
import DateRangePicker from '@pluto/daterange-picker/DateRangePickerContainer';
import PlutoAutocomplete from '@pluto/autocomplete/AutocompleteContainer';
import PlutoSelect from '@pluto/select';
import {handleMount, QCFiltersContainerProps} from '../QCFiltersContainer';

export default function QCJobsFiltersContainer(props: QCFiltersContainerProps) {
    const {
        title,
        filters,
        handleStatusChange,
        handleContentPartnersChange,
        handleContentTypesChange,
        handleTitleChange,
        dueDates,
        finishDates,
        onDueDateRangeSelect,
        onFinishDateRangeSelect,
        contentPartners,
        setContentPartners,
        contentTypes,
        users,
        setUsers,
        qcJobsStatuses,
        setQCStatuses,
    } = props;

    const onMount = handleMount({
        contentPartners,
        setContentPartners,
        contentTypes,
        users,
        setUsers,
        qcJobsStatuses,
        setQCStatuses,
    });
    useEffect(onMount, []);
    return (
        <div className="qc-filters-container">
            <div className="qc-filter qc-filter__search">
                <Input
                    autoComplete="off"
                    id="qc-filter__input"
                    value={title}
                    placeholder="Filter by title or ID"
                    onChange={handleTitleChange}
                />
                <SearchIcon className="qc-filter__search_icon" />
            </div>
            <div className="qc-filter qc-filter__due-date">
                <DateRangePicker
                    dates={dueDates}
                    onDatesSelect={onDueDateRangeSelect}
                    placeholder="Due date"
                />
                <EventIcon className="qc-filter__due-date_icon" />
            </div>
            <div className="qc-filter qc-filter__due-date">
                <DateRangePicker
                    dates={finishDates}
                    onDatesSelect={onFinishDateRangeSelect}
                    placeholder="Finished date"
                />
                <EventIcon className="qc-filter__finish-date_icon" />
            </div>
            <FormControl className="qc-filter qc-filter__job-status">
                <PlutoSelect
                    filterKey="qcJobStatus"
                    filters={filters}
                    placeholder="Status"
                    value={filters.qcJobStatus}
                    onChange={handleStatusChange}
                    options={qcJobsStatuses.statuses}
                    isLoading={qcJobsStatuses.isLoading}
                />
            </FormControl>
            <div className="qc-filter qc-filter__content-partner">
                <PlutoAutocomplete
                    placeholder="Content partner"
                    values={filters.contentPartnerId}
                    onChange={handleContentPartnersChange}
                    options={contentPartners.data.rows}
                    isLoading={contentPartners.isLoading}
                />
            </div>
            <div className="qc-filter qc-filter__content-type">
                <PlutoAutocomplete
                    placeholder="Content type"
                    values={filters.contentItemType}
                    onChange={handleContentTypesChange}
                    options={contentTypes.data}
                    isLoading={contentTypes.isLoading}
                />
            </div>
        </div>
    );
}
